import { io } from 'socket.io-client';
import Api from '../api/ApiUrl'

// const SOCKET_URL = 'http://localhost:9000/auction'; // Adjust the URL as needed
// const SOCKET_URL = `${Api}/auction`;
const SOCKET_URL = `${Api}/notifications`; // Adjust the URL as needed
 // Adjust the URL as needed

const socket = io(SOCKET_URL, {
  autoConnect: false
});

export default socket;
